import { appRoutes } from 'src/app/app.routing.module';
import { AcoesMenuEnum } from 'src/app/core/enum/acoes-menu-enum';
import { ModuloMenuSistemaCodigoDescricao } from 'src/app/core/enum/modulo-menu-sistema-enum';
import { SistemaEnum } from 'src/app/core/enum/sistema-enum';
import { BpMenuSistemaModel } from 'src/app/core/model/menu/bp-menu-sistema-model';
import { UsuarioPerfilResponse } from 'src/app/core/response/usuario-perfil/usuario-perfil-response';
import { SessionService } from 'src/app/core/services/session/session.service';
import { MenuSistemaEnum } from 'src/app/core/enum/menu-sistema-enum';

export function construirMenu(session: SessionService, sistema: SistemaEnum, nomeSistema: string, usuarioPerfilResponse?: UsuarioPerfilResponse): BpMenuSistemaModel[] {
  const usuarioPerfilSistemas = usuarioPerfilResponse ? usuarioPerfilResponse : session.getUserSession();

  const usuarioPerfilSistemaResponse = usuarioPerfilSistemas.usuarioPerfilSistemas.find((x) => x.sistemaID === sistema);

  if (!usuarioPerfilSistemaResponse) {
    return;
  }

  let menus = usuarioPerfilSistemaResponse.usuarioPerfilMenus;
  menus = removerDuplicatas(menus, 'menuID');
  // Filtra os menus que possuem menuID presente no MenuSistemaEnum- Nicolas
  menus = menus.filter((menu) => { return menu.menuID in MenuSistemaEnum });

  const categoriasDisponiveis = ModuloMenuSistemaCodigoDescricao.filter((categoria) =>
    categoria.descricao.startsWith(nomeSistema)
  );

  const menuRetorno = obterArrayMenusPorCategorias(categoriasDisponiveis);

  const rotasSistemaMap = new Map<number, string>();

  appRoutes
    .filter((x) => x.data && x.data.menuId)
    .forEach((route) => rotasSistemaMap.set(route.data.menuId, route.path));

  menuRetorno.forEach((m) => {
    const submenus = menus.filter((x) => x.moduloId === m.id);
    m.subMenus = submenus.map((sub) => {
      const rota = rotasSistemaMap.get(sub.menuID);
      return { ...sub, rota };
    });
  });

  const menusComSubmenus = menuRetorno.filter((menu) => menu.subMenus.length > 0);

  menusComSubmenus.map((menu: BpMenuSistemaModel): void => {
    switch (menu.titulo) {
      case ' Administrativo':
        menu.icon = 'btn-nav-adm';
        return;
      case ' Cadastro':
        menu.icon = 'btn-nav-cad';
        return;
      case ' Prestação':
        menu.icon = 'btn-nav-prest';
        return;
      case ' Aprovação':
        menu.icon = 'btn-nav-cad';
        return;
      case ' (VT)Relatórios':
        menu.icon = 'btn-nav-rel';
        return;
      case ' Relatórios':
        menu.icon = 'btn-nav-rel';
        return;
      case ' Segurança':
        menu.icon = 'btn-nav-seg';
        return;
      case ' VT':
        menu.icon = 'btn-nav-adm'
        return;
      default:
        menu.icon = 'description';
        return;
    }
  });

  return menusComSubmenus;
}

function obterArrayMenusPorCategorias(categoriasDisponiveis: { codigo: string; descricao: string }[]) {
  let retornoMenu: BpMenuSistemaModel[] = [];
  categoriasDisponiveis.forEach((categoria) => {
    let nomeSeparado: string[] = categoria.descricao.split('_');
    let nomeModulo: string = '';
    nomeSeparado.forEach((nome: string, i: number): void => {
      if (i !== 0) {
        nomeModulo = `${nomeModulo} ${nome}`;
      }
    });

    retornoMenu.push(new BpMenuSistemaModel(+categoria.codigo, nomeModulo, true, '', []));
  });

  return retornoMenu;
}

export function possuiPermisaoPorAcao(acao: AcoesMenuEnum, session: SessionService): boolean {
  let retorno: boolean = false;
  const sistemaIndex: number = session.userSessionPermissions.usuarioPerfilSistemas.findIndex(
    (usuarioPerfil) => usuarioPerfil.sistemaID === SistemaEnum.Bilhetagem
  );
  if (sistemaIndex > 0) {
    session.userSessionPermissions.usuarioPerfilSistemas[sistemaIndex].usuarioPerfilMenus.forEach((menu) => {
      if (menu.usuarioPerfilAcoes.find((x) => x.acaoID === acao)) {
        retorno = true;
      }
    });
  }
  return retorno;
}

function removerDuplicatas(data: any[], key: string): Array<any> {
  const uniqueArray: any[] = [];

  for (let i = 0; i < data.length; i++) {
    const currentElement = data[i];
    const elementPresent = uniqueArray.some((element) => element[key] === currentElement[key]);

    if (!elementPresent) {
      uniqueArray.push(currentElement);
    }
  }

  return uniqueArray;
}
